
import { defineComponent, reactive, Ref, ComputedRef, computed, onMounted, ref } from 'vue'
import { LoadingOutlined, PlusOutlined, CloudUploadOutlined, CloudDownloadOutlined, InfoCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue';
import type { UploadChangeParam, UploadProps, TableProps } from 'ant-design-vue'
import { useStore } from 'vuex'
// import {StateType as SkuStateType} from './store'
import {StateType as UploadStateType} from '@/store/upload'
import { Form } from 'ant-design-vue'
import {message, TableColumnType} from 'ant-design-vue'
const useForm = Form.useForm;
import downloadfile from '@/utils/download'
import fileUrl from '@/utils/downloadurl'
interface batchImport {
    list: Ref<any[]>;
    loading: Ref<boolean>;
    handleUpload: (info: any) => void;
    handleDownFile: (e: MouseEvent) => void;
    handleCtrl: (e: MouseEvent) => void;
    handleAddList: (e: MouseEvent) => void;
}

export default defineComponent({
    name: 'batchImport',
    components:{
        LoadingOutlined,
        PlusOutlined,
        CloudUploadOutlined, 
        CloudDownloadOutlined, 
        InfoCircleOutlined,
        ExclamationCircleOutlined
    },
    emits: ['update:visible'],
    setup(props, {emit}):batchImport {
        const store = useStore<{upload:UploadStateType}>()
        const userMsg = JSON.parse(String(localStorage.getItem('userMsg'))) || {}
        const list = ref<any[]>([])
        const loading = ref<boolean>(false)
        const handleUpload = (info: any) => {
            const formData = new FormData()
            formData.append('file', info.file)
            formData.append('userCode', userMsg.userCode)
            importsku(formData)
        }

        //导入
        // const list = computed<any>(() => store.state.upload.batchImportRes)
        const importsku = async(params:any) => {
            loading.value = true
            try {
                const res: boolean = await store.dispatch('upload/batchImportUrlFn',params)
                if(res===true){
                    if(store.state.upload.batchImportRes.length > 0){
                        list.value = store.state.upload.batchImportRes
                    }else{
                        emit('update:visible', false)
                        message.success('导入成功')
                    }
                }
            } catch (error) {
                message.warning('error')
            }
            loading.value = false
        }

        //下载模版
        const handleDownFile = (e: MouseEvent) => {
            const data = {id:'32674'}
            try {
                downloadfile({
                    params: data,
                    url: 'fileUrl.filedownurl',
                    meth: 'get',
                    type: 'text/plain',
                    filename: `批量下单模版${new Date().getTime()}.xlsx`
                })
            } catch (error) {
                message.warning('error=>'+error)
            }
        }

        const handleCtrl = (e:MouseEvent) => {
            emit('update:visible', false)
        }

        const handleAddList = (e:MouseEvent) => {
            list.value = []
        }

        onMounted(()=>{
            list.value = []
        })


        return {
            handleUpload,
            list,
            handleDownFile,
            handleCtrl,
            handleAddList,
            loading
        }
    },
})
